import { api, ConveyorUpdatePayload, responseErrorCheck, TmrBaseResource } from 'core/api'

export class InboundConveyorApi extends TmrBaseResource {
  static async getConveyor(conveyorId: string): Promise<any> {
    return api.get(`api/v1/conveyors/${conveyorId}`).then(responseErrorCheck)
  }

  static async changeConveyor(data: ConveyorUpdatePayload): Promise<any> {
    return api.put(`api/v1/conveyors`, data).then(responseErrorCheck)
  }
}
